import { useEthers, useContractFunction, useCall, useTokenBalance, useContractCall } from "@usedapp/core";
import { constants, utils, BigNumber } from "ethers";

import {
  bep_20_contract,
  bep_20_interface,
  bep_20_address,

  busd_bank_interface,
  busd_bank_address,
  busd_bank_contract,

} from '../constants/contracts';

export function useViewUserInfo() {
  const { account } = useEthers();
  const userInfo = useContractCall({
    abi: busd_bank_interface,
    address: busd_bank_address,
    method: "viewUserInfo",
    args: [account], 
  }) ?? [];
  
  if (userInfo.length !== 0){
    return userInfo;
  }
  return [0, 0, 0, 0, 0, 0, false];
}

export function useViewUserEstYield() {
  const { account } = useEthers();
  const [dailyYield] = useContractCall({
    abi: busd_bank_interface,
    address: busd_bank_address,
    method: "viewUserEstYield",
    args: [account], 
  }) ?? [];
  
  return dailyYield;
}

export function useCalculateReward() {
  const { account } = useEthers();
  const [reward] = useContractCall({
    abi: busd_bank_interface,
    address: busd_bank_address,
    method: "calculateReward",
    args: [account], 
  }) ?? [];
  
  return reward;
}

export function useOwnsNFT() {
  const { account } = useEthers();
  const [ownsNft] = useContractCall({
    abi: busd_bank_interface,
    address: busd_bank_address,
    method: "ownsNFT",
    args: [account], 
  }) ?? [];
  
  return ownsNft;
}


export function useApproveBUSD(){
    const { state, send, events, resetState } = useContractFunction(bep_20_contract, "approve");
    return { state, send, events, resetState };
}


export function useStake(){
  const { state, send, events, resetState } = useContractFunction(busd_bank_contract, "stake");
  return { state, send, events, resetState };
}


export function usePartialWithdraw(){
  const { state, send, events, resetState } = useContractFunction(busd_bank_contract, "partialWithdraw");
  return { state, send, events, resetState };
}

export function useCompound(){
  const { state, send, events, resetState } = useContractFunction(busd_bank_contract, "compound");
  return { state, send, events, resetState };
}

export function useWithdrawRewards(){
  const { state, send, events, resetState } = useContractFunction(busd_bank_contract, "withdrawRewards");
  return { state, send, events, resetState };
}